import { connect } from 'react-redux'
import { createWidget } from 'pages/widgets/form-actions/create/actions'
import Form from 'pages/widgets/form'
import { getInitialThreadVentureValues } from './initialValues'

const mapDispatch = {
  onSubmit: createWidget
}

const date = new Date().valueOf()

export default connect(
  () => ({ initialValues: getInitialThreadVentureValues(date) }),
  mapDispatch
)(Form)



// WEBPACK FOOTER //
// ./src/pages/widgets/thread_venture/create/container/index.js